import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import "../../styles/newbusiness.css";
import { useLocation, useNavigate } from "react-router-dom";
import { getServerURL } from "../../helper/envConfig";
import api from "../../helper/api";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
const AITrail = () => {
    const trailId = 5;
    const { t } = useTranslation("AITrail");
    const serverURL = getServerURL();
    const location = useLocation();
    const navigate = useNavigate();
    const [caseStudies, setCaseStudies] = useState([]);
    const [user, setUser] = useState({});

    const getSteps = async () => {
        try {
            const response = await api.getWithToken(
                `${serverURL}trails/steps/`
            );
            setCaseStudies(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (!location.state || !location.state.userData) {
            navigate("/sign-in");
            return;
        }
        setUser(location.state.userData);
        getSteps();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNavigate = () => {
        const stateData = {
            state: {
                userData: user,
                step: true,
                trailId: trailId,
                name: t("ai_learning"),
            },
        };
        navigate("/free-trail/case-study", stateData);
    };

    return (
        <>
            <Header />
            <main className="business_data_privacy_trail">
                <section>
                    <div className="trail_progress">
                        <div className="container">
                            <div className="row align-items-center g-4">
                                <div className="col-12 col-md-7 order-2 order-md-1">
                                    <span className="badge text-capitalize">
                                        {t("hi")} {user?.name},
                                    </span>

                                    <p>
                                        {t("welcometothe")}{" "}
                                        {location.state.name} {t("trail_intro")}
                                    </p>
                                    <h3>
                                        {t("ai_learning")} {t("trail_heading")}
                                    </h3>
                                    <button
                                        className="btn btn-primary d-inline-flex align-items-center gap-3 link_button"
                                        onClick={handleNavigate}
                                    >
                                        {t("begintrail")}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={22}
                                            height={14}
                                            viewBox="0 0 22 14"
                                            fill="none"
                                        >
                                            <path
                                                d="M1 6.99854H21L16 1"
                                                stroke="#fff"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21 6.99854L16 13"
                                                stroke="#fff"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                <div className="col-12 col-md-5 d-flex justify-content-end order-1 order-md-2">
                                    <img
                                        src="/new-business/discussion-cuate.webp"
                                        className="pt-md-5"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="data_privacy_overview py-5">
                    <div className="container">
                        <div className="d-md-flex justify-content-between align-items-center pb-4 pb-lg-5">
                            <h2>
                                {t("ai_learning")} {t("trailoverview")}{" "}
                            </h2>
                            <button
                                onClick={handleNavigate}
                                className="btn-primary d-inline-flex align-items-center gap-3 mt-3 mt-md-0 rounded-3"
                            >
                                <span className="text-white">
                                    {t("start")}{" "}
                                </span>
                                <svg
                                    className="ms-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={22}
                                    height={14}
                                    viewBox="0 0 22 14"
                                    fill="none"
                                >
                                    <path
                                        d="M1 6.99854H21L16 1"
                                        stroke="#fff"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M21 6.99854L16 13"
                                        stroke="#fff"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div className="row g-4">
                            {caseStudies?.map((caseStudy, index) => (
                                <div className="col-12" key={index}>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-start align-content-md-center gap-4 flex-column flex-md-row">
                                                <img
                                                    src={caseStudy.icon}
                                                    alt=""
                                                />
                                                <div>
                                                    <h4>{caseStudy.name}</h4>
                                                    <p className="mb-2">
                                                        {caseStudy.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default AITrail;
